/* eslint-disable no-magic-numbers */
import {
  Flex,
  Icon,
  IconButton,
  Text,
  Radio,
  RadioGroup,
  Input,
  FormLabel,
  Select,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaFilter, FaSearch, FaTrash } from 'react-icons/fa'
import { FILTERS, ORDERING } from './constants'

const Filters = ({
  isReleased,
  isSales,
  isHot,
  isListenable,
  isEarlyAccess,
  isDeleted,
  handleReleasedChange,
  handleSalesChange,
  handleHotChange,
  handleListenableChange,
  handleEarlyAccessChange,
  handleDeletedChange,
  status,
  handleStatusChange,
  handleReleaseFromChange,
  handleReleaseToChange,
  releaseFrom,
  releaseTo,
  handleFromSaleDateChange,
  handleToSaleDateChange,
  fromSaleDate,
  toSaleDate,
  ordering,
  handleOrderingChange,
  sortBy,
  handleSortByChange,
  handlePerPageChange,
  perPage,
  onSearchOpen,
}) => {
  const [shouldShowFilters, setShouldShowFilters] = useState(false)

  const handleShowFilters = () => {
    setShouldShowFilters(curr => !curr)
  }

  return (
    <Flex
      position='relative'
      w='100%'
      direction='column'
      gap='10px'
      minH='125px'
      mb={shouldShowFilters ? '16px' : '0'}
    >
      {shouldShowFilters && (
        <Flex gap='14px' align='flex-start'>
          <Flex gap='14px' flexWrap='wrap' align='flex-start'>
            <RadioGroup
              value={isDeleted}
              onChange={handleDeletedChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Deleted
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>
            <RadioGroup
              value={isReleased}
              onChange={handleReleasedChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Released
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>

            <RadioGroup
              value={isSales}
              onChange={handleSalesChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Sales
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>

            <RadioGroup
              value={isHot}
              onChange={handleHotChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Hot
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>

            <RadioGroup
              value={isListenable}
              onChange={handleListenableChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Listenable
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>

            <RadioGroup
              value={isEarlyAccess}
              onChange={handleEarlyAccessChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Is Early Access
              </Text>
              <Radio value={'yes'}>Yes</Radio>
              <Radio value={'no'}>No</Radio>
              <Radio value={'omitted'}>Omitted</Radio>
            </RadioGroup>

            <RadioGroup
              value={status}
              onChange={handleStatusChange}
              gap='10px'
              display='flex'
              flexDirection='column'
              colorScheme='purple'
              size='lg'
              borderRadius='md'
              bg='white'
              p='1'
              boxShadow='lg'
            >
              <Text fontWeight='bold' fontSize='md' color='purple.700' mb={2}>
                Status
              </Text>
              <Radio value={'APPROVED'}>Approved</Radio>
              <Radio value={'DRAFT'}>Draft</Radio>
              <Radio value={'all'}>All</Radio>
            </RadioGroup>
          </Flex>

          <Flex gap='10px' direction='column' w='100%'>
            <Flex gap='10px' maxW='100%' w='fit-content'>
              <Flex direction='column' gap='10px' w='100%'>
                <Flex direction='row' gap='10px' align='center'>
                  <FormLabel
                    fontWeight='bold'
                    fontSize='md'
                    color='purple.700'
                    mb={2}
                    htmlFor='releaseFrom'
                    whiteSpace='nowrap'
                  >
                    Release from
                  </FormLabel>
                  <Input
                    type='date'
                    placeholder='Release from'
                    value={releaseFrom}
                    onChange={handleReleaseFromChange}
                    id='releaseFrom'
                    w='150px'
                  />
                  <IconButton
                    icon={<Icon as={FaTrash} color='red.500' />}
                    aria-label='Clear filters'
                    onClick={() =>
                      handleReleaseFromChange({ target: { value: '' } })
                    }
                    size='md'
                    isDisabled={!releaseFrom}
                  />
                </Flex>
                <Flex direction='row' gap='10px' align='center'>
                  <FormLabel
                    fontWeight='bold'
                    fontSize='md'
                    color='purple.700'
                    mb={2}
                    htmlFor='releaseTo'
                    whiteSpace='nowrap'
                  >
                    Release to
                  </FormLabel>
                  <Input
                    type='date'
                    placeholder='Release to'
                    value={releaseTo}
                    onChange={handleReleaseToChange}
                    id='releaseTo'
                    w='150px'
                  />
                  <IconButton
                    icon={<Icon as={FaTrash} color='red.500' />}
                    aria-label='Clear filters'
                    onClick={() =>
                      handleReleaseToChange({ target: { value: '' } })
                    }
                    size='md'
                    isDisabled={!releaseTo}
                  />
                </Flex>
              </Flex>
              <Flex direction='column' gap='10px' w='100%'>
                <Flex direction='row' gap='10px' align='center'>
                  <FormLabel
                    fontWeight='bold'
                    fontSize='md'
                    color='purple.700'
                    mb={2}
                    htmlFor='fromSaleDate'
                    whiteSpace='nowrap'
                  >
                    From sale date
                  </FormLabel>
                  <Input
                    type='date'
                    placeholder='From sale date'
                    value={fromSaleDate}
                    onChange={handleFromSaleDateChange}
                    id='fromSaleDate'
                    w='150px'
                  />
                  <IconButton
                    icon={<Icon as={FaTrash} color='red.500' />}
                    aria-label='Clear filters'
                    onClick={() =>
                      handleFromSaleDateChange({ target: { value: '' } })
                    }
                    size='md'
                    isDisabled={!fromSaleDate}
                  />
                </Flex>
                <Flex direction='row' gap='10px' align='center'>
                  <FormLabel
                    fontWeight='bold'
                    fontSize='md'
                    color='purple.700'
                    mb={2}
                    htmlFor='toSaleDate'
                    whiteSpace='nowrap'
                  >
                    To sale date
                  </FormLabel>
                  <Input
                    type='date'
                    placeholder='To sale date'
                    value={toSaleDate}
                    onChange={handleToSaleDateChange}
                    id='toSaleDate'
                    w='150px'
                  />
                  <IconButton
                    icon={<Icon as={FaTrash} color='red.500' />}
                    aria-label='Clear filters'
                    onClick={() =>
                      handleToSaleDateChange({ target: { value: '' } })
                    }
                    size='md'
                    isDisabled={!toSaleDate}
                  />
                </Flex>
              </Flex>
            </Flex>
            <Flex gap='10px'>
              <Flex direction='row' gap='10px' align='center'>
                <FormLabel
                  fontWeight='bold'
                  fontSize='md'
                  color='purple.700'
                  mb={2}
                  htmlFor='ordering'
                  whiteSpace='nowrap'
                >
                  Sort by
                </FormLabel>
                <Select
                  value={sortBy}
                  onChange={handleSortByChange}
                  id='ordering'
                >
                  {Object.values(FILTERS).map(order => (
                    <option key={order} value={order}>
                      {order}
                    </option>
                  ))}
                </Select>
              </Flex>
              <Flex direction='row' gap='10px' align='center'>
                <FormLabel
                  fontWeight='bold'
                  fontSize='md'
                  color='purple.700'
                  mb={2}
                  htmlFor='ordering'
                  whiteSpace='nowrap'
                >
                  Ordering
                </FormLabel>
                <Select
                  value={ordering}
                  onChange={handleOrderingChange}
                  id='ordering'
                >
                  {Object.values(ORDERING).map(order => (
                    <option key={order} value={order}>
                      {order}
                    </option>
                  ))}
                </Select>
              </Flex>
              <Flex direction='row' gap='10px' align='center'>
                <FormLabel
                  fontWeight='bold'
                  fontSize='md'
                  color='purple.700'
                  mb={2}
                  htmlFor='perPage'
                  whiteSpace='nowrap'
                >
                  Per page
                </FormLabel>
                <Select
                  value={perPage}
                  onChange={handlePerPageChange}
                  id='perPage'
                >
                  {[10, 20, 30].map(perPage => (
                    <option key={perPage} value={perPage}>
                      {perPage}
                    </option>
                  ))}
                </Select>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      )}

      <IconButton
        icon={<Icon as={FaFilter} color='white' />}
        aria-label={shouldShowFilters ? 'Hide filters' : 'Show filters'}
        onClick={handleShowFilters}
        position='absolute'
        right='0'
        top='50%'
        transform='translateY(-50%)'
        ml='16px'
        bg={shouldShowFilters ? 'purple.500' : 'teal.500'}
        color='white'
        _hover={{
          bg: shouldShowFilters ? 'purple.600' : 'teal.600',
          color: 'white',
        }}
        borderRadius='md'
        boxShadow='md'
        size='lg'
      />

      <IconButton
        icon={<Icon as={FaSearch} color='white' />}
        width='fit-content'
        onClick={() => {
          onSearchOpen()
        }}
        position='absolute'
        right='0'
        top='50%'
        transform='translateY(75%)'
        ml='16px'
        bg='yellow.500'
        color='white'
        _hover={{
          bg: 'yellow.600',
          color: 'white',
        }}
        borderRadius='md'
        boxShadow='md'
        size='lg'
      />
    </Flex>
  )
}

export default Filters
